import {IBridge} from "@kta20-core/bridge-manager";
import {ICoreBridge} from "@kta20-core/interfaces/i-core-bridge";
import {I18n} from "@kta20-core/interfaces/i-i18n";

export class CoreBridge implements IBridge, ICoreBridge {

    _i18n: I18n;

    get i18n(): I18n {
        return this._i18n;
    }

    static factory(i18n:I18n): IBridge {
        const br = new CoreBridge();
        br._i18n = i18n;
        return br;
    };

}